import { cn } from '@ludus/ui'

interface MetricProps {
  /** Display value — pre-formatted (e.g. `€1.8M`, `13d`, `7`). */
  value: string
  /** Short uppercase label rendered under the value. */
  label: string
  /** Optional warning tone used for stuck / overdue counts. */
  tone?: 'default' | 'warning'
  className?: string
}

/**
 * Compact value-over-label metric used inside the focused-stage header. Designed for
 * inline rows: large bold numeric on top, tiny uppercase context label underneath.
 *
 * Lives at feature level (not packages/ui) until a second feature needs the same
 * treatment; promote then.
 */
export function Metric({ value, label, tone = 'default', className }: MetricProps) {
  return (
    <div className={cn('flex flex-col items-start gap-0.5', className)}>
      <span
        className={cn(
          'text-lg font-bold leading-none tabular-nums tracking-tight',
          tone === 'warning' ? 'text-toast-warning-text' : 'text-foreground',
        )}
      >
        {value}
      </span>
      <span className="text-[10px] font-semibold uppercase tracking-[0.16em] text-muted">
        {label}
      </span>
    </div>
  )
}
